import apiHandler from "../core/apiHandler";

const creditFiscalSaleApi = apiHandler('credit-fiscal-sales');
export default creditFiscalSaleApi;
